import styled from "@emotion/styled"

const IntroduceContainer = styled.div`
    flex: 1;
    margin-top: 24rem;
`
const IntroduceLine = styled.div`
    font-weight: 400;
    font-size: 14rem;
    width: 343rem;
    margin: 0 auto 12rem;
    line-height: 20rem;
`

const IntroduceVideo = styled.video`
    width: 343rem;
    height: 192rem;
    margin: 0 16rem 12rem;
`

const OverviewTitle = styled.div`
    width: 343rem;
    height: 24rem;
    font-weight: 590;
    font-size: 18rem;
    line-height: 24rem;
    vertical-align: middle;
    margin: 0 auto;
`
export default function Introduce() {
    return (
        <>
            <IntroduceContainer>
                <IntroduceLine>
                    GoTech Entertainment Inc. is the top online gambling site in the Philippines
                    registered under Securities and Exchange Commission (SEC) since 2022. We are
                    committed to giving our users a fun, secure, and safe gaming experience, backed
                    by state-of-the-art equipment and a committed staff of experts.
                </IntroduceLine>
                {/* <IntroduceVideo controls ></IntroduceVideo> */}
                <OverviewTitle>Company Overview</OverviewTitle>
                <IntroduceLine>
                    FILBET.COM is owned by GoTech Entertainment Inc. which is an online Casino
                    Platform approved and regulated by the Philippine Amusement and Gaming
                    Corporation (PAGCOR) with the best gaming experiences in Sports Betting, Live
                    Casino, E-Bingo and Slot Games.
                </IntroduceLine>
                {/* <OverviewTitle>Sponsorship</OverviewTitle> */}
                {/* <IntroduceLine>
                    FILBET.COM is also a proud Maharlika Pilipinas Basketball League (MPBL) Team
                    Pasay Voyager and Bacoor Strikers Sponsor.
                </IntroduceLine> */}
            </IntroduceContainer>
        </>
    )
}
